export const isZip = (value) => {
  if (!value || /^\d{5}$/.test(value)) {
    return undefined;
  }

  return 'Invalid';
};

export default isZip;
